import gql from "graphql-tag";
import graphqlClient from "@/http/graphql/card";

const GET_STATES = `
	get_state_from_country {
		id
		name
	}
`;

const GET_DISTRICTS = `
	get_district_from_state(state_id: $state_id) {
		id
		name
	}
`;

const GET_WARDS = `
	get_ward_from_district(district_id: $district_id) {
		id
		name
	}
`;

export default {
	init() {},

	fetchStates() {
		const queryOptions = {
			query: gql`query States {
				${GET_STATES}
			}
			`
		};
		return graphqlClient.query(queryOptions).then(response => {
			return {
				states: response.data.get_state_from_country
			};
		});
	},
	fetchDistricts(payload) {
		const queryOptions = {
			query: gql`query Districts ($state_id: Int!) {
				${GET_DISTRICTS}
			}
			`,
			variables: {
				state_id: payload.state_id
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				districts: response.data.get_district_from_state
			};
		});
	},
	fetchWards(payload) {
		const queryOptions = {
			query: gql`query Wards ($district_id: Int!) {
				${GET_WARDS}
			}
			`,
			variables: {
				district_id: payload.district_id
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				wards: response.data.get_ward_from_district
			};
		});
	}
};
